import type { ManagerOptions, SocketOptions } from 'socket.io-client';

export function isRelativeServiceUrl(url: string | undefined): url is string {
  return Boolean(url?.startsWith('/'));
}

function normalizeServiceUrl(url: string): string {
  return url.replace(/\/$/, '');
}

export function resolveWebSocketUrl(url: string): string {
  if (!url) return url;

  if (url.startsWith('http://')) {
    return url.replace(/^http:\/\//, 'ws://');
  }

  if (url.startsWith('https://')) {
    return url.replace(/^https:\/\//, 'wss://');
  }

  if (isRelativeServiceUrl(url)) {
    const protocol =
      typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = typeof window !== 'undefined' ? window.location.host : 'localhost';
    return `${protocol}//${host}${url}`;
  }

  return url;
}
